import { CONTACT_INFO } from "@/lib/constants";

export default function Visit() {
  return (
    <section
      id="visit"
      data-testid="visit-section"
      className="bg-[#FDFBF7] py-24 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12">
          <div className="col-span-12 md:col-span-6">
            <p className="font-mono-accent text-[12px] text-[#7A2021] mb-5">
              — Find Us
            </p>
            <h2
              data-testid="visit-heading"
              className="font-serif-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight text-[#1A1713]"
            >
              Visit the <br />
              <em className="text-[#7A2021]">brasserie.</em>
            </h2>
            <p className="mt-8 text-[#5C5449] max-w-md leading-relaxed">
              Tucked along Westheimer in the Montrose, two doors down from the
              old florist. Look for the brass awning and the warm light.
            </p>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 border-t border-[#E4DECD] pt-10">
              <div>
                <p className="font-mono-accent text-[12px] text-[#7A2021] mb-3">
                  Address
                </p>
                <p className="font-serif-display text-2xl text-[#1A1713]">
                  {CONTACT_INFO.street}
                </p>
                <p className="text-[#5C5449] mt-1">{CONTACT_INFO.cityState}</p>
              </div>
              <div>
                <p className="font-mono-accent text-[12px] text-[#7A2021] mb-3">
                  Direct
                </p>
                <p className="font-serif-display text-2xl text-[#1A1713]">
                  {CONTACT_INFO.phone}
                </p>
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="text-[#5C5449] mt-1 brass-link inline-block"
                >
                  {CONTACT_INFO.email}
                </a>
              </div>
              <div className="md:col-span-2">
                <p className="font-mono-accent text-[12px] text-[#7A2021] mb-4">
                  Service Hours
                </p>
                <ul className="space-y-2">
                  {CONTACT_INFO.hours.map((h) => (
                    <li
                      key={h.day}
                      className="flex justify-between max-w-md border-b border-[#E4DECD] pb-2"
                    >
                      <span className="text-[#1A1713]">{h.day}</span>
                      <span className="text-[#5C5449] font-mono-accent text-[13px]">
                        {h.time}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-6">
            <div className="aspect-[4/5] overflow-hidden border border-[#E4DECD]">
              <iframe
                title="Ladiosa's location"
                src="https://www.google.com/maps?q=Westheimer+Rd+Houston+TX&output=embed"
                className="w-full h-full grayscale"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
